import {
  Box,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useParticipantsHumansControllerGetHumanTicketsAndMailingQuery } from '@api/admin/adminApi';
import { LoadingSpinner } from '@components/LoadingSpinner';
import { DateService } from '@services/DateService';
import { Routes } from '@navigation/routes';
import { buildRoutePath } from '@navigation/buildRoutePath';
import colors from '@styles/colors.module.scss';
import { Icon } from '@components/Icon';
import { Tag } from '@components/Tag';
import { Fragment, useState } from 'react';
import cn from 'classnames';
import styles from './styles.module.scss';

export const TicketsMailingHistory = ({ id }: { id: string }) => {
  const { data, isLoading } = useParticipantsHumansControllerGetHumanTicketsAndMailingQuery({ id });
  const [expandedRows, setExpandedRows] = useState<string[]>([]);

  const onButtonClick = (id: string) => {
    window.open(buildRoutePath([Routes.tickets, Routes.id], { absolute: true, params: { id } }), '_blank');
  };
  const onRowClick = (id: string) => {
    if (expandedRows.includes(id)) {
      setExpandedRows(expandedRows.filter((item) => item !== id));
    } else {
      setExpandedRows([...expandedRows, id]);
    }
  };

  return (
    <Stack gap="20px">
      <Typography variant="h2">История обращений</Typography>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <TableContainer className={styles.tableContainer}>
            <Table className={styles.table}>
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ width: 72, whiteSpace: 'nowrap' }}>
                    <Typography variant="body2">Тип</Typography>
                  </TableCell>
                  <TableCell align="left" sx={{ width: 200, whiteSpace: 'nowrap' }}>
                    <Typography variant="body2">Дата создания</Typography>
                  </TableCell>
                  <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                    <Typography variant="body2">Тема</Typography>
                  </TableCell>
                  <TableCell align="left" sx={{ width: 200, whiteSpace: 'nowrap' }}>
                    <Typography variant="body2">Статус</Typography>
                  </TableCell>
                  <TableCell align="left" sx={{ width: 64, whiteSpace: 'nowrap' }} />
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((item) => (
                  <Fragment key={item.id}>
                    <TableRow
                      onClick={() => !!item.text && onRowClick(item.id)}
                      className={cn([
                        styles.row,
                        styles.canClick,
                        { [styles.withSubRow]: expandedRows.includes(item.id) },
                      ])}>
                      <TableCell align="left" sx={{ width: 72, whiteSpace: 'nowrap' }}>
                        <Box display="flex" alignItems="center">
                          <Icon
                            name={item.isTicket ? 'request' : 'bubble'}
                            color={item.isTicket ? colors.black : colors.red}
                          />
                        </Box>
                      </TableCell>
                      <TableCell align="left" sx={{ width: 200, whiteSpace: 'nowrap' }}>
                        <Typography variant="body2" component="p">
                          {DateService.getLocalDate(item.createdAt)}
                        </Typography>
                      </TableCell>
                      <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                        <Typography variant="body1" component="p">
                          {item.subject}
                        </Typography>
                      </TableCell>
                      <TableCell align="left" sx={{ width: 200, whiteSpace: 'nowrap' }}>
                        {item.isTicket && (
                          <Tag
                            label={item.resolved ? 'Решено' : 'Новое'}
                            sx={{
                              width: 84,
                              background: item.resolved ? colors.success : colors.lightRed,
                              color: item.resolved ? colors.white : colors.black,
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell align="left" sx={{ width: 64, whiteSpace: 'nowrap' }}>
                        {item.isTicket && (
                          <Button
                            className={styles.arrowButton}
                            onClick={(event) => {
                              event.stopPropagation();
                              onButtonClick(item.id);
                            }}>
                            <Icon name="chevronRight" />
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                    {expandedRows.includes(item.id) && item.text && (
                      <TableRow className={styles.textRow}>
                        <TableCell />
                        <TableCell align="left" colSpan={4}>
                          <Typography variant="body2" component="p" dangerouslySetInnerHTML={{ __html: item.text }} />
                        </TableCell>
                      </TableRow>
                    )}
                  </Fragment>
                ))}
              </TableBody>
            </Table>
            {!data?.length && (
              <Box className={styles.noData}>
                <Typography variant="body1">Нет данных</Typography>
              </Box>
            )}
          </TableContainer>
        </>
      )}
    </Stack>
  );
};
